import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';
import CheckBox from 'components/CheckBox';
import Select from 'components/Select';

const ALL_GROUPS_ID = 'ALL_GROUPS';

const GroupMultiSelect = ({
  list = [],
  value = [],
  onChange,
  disabled = false,
  className = '',
  style,
  label = 'Select Group',
  testIdPrefix = 'group-select-item',
  partnerId = '',
}) => {
  const getDisplayValue = () => {
    if (value.includes(ALL_GROUPS_ID)) return 'All Groups';
    if (!value?.length) return '';
    const selectedGroups = list.filter(
      g => value.includes(g.group_id) && g.group_id !== ALL_GROUPS_ID,
    );
    return selectedGroups.map(g => g.group_name).join(', ');
  };

  const handleChange = (e) => {
    const newValues = Array.isArray(e.target.value)
      ? e.target.value
      : [e.target.value];

    const wasAllSelected = value.includes(ALL_GROUPS_ID);
    const isAllSelected = newValues.includes(ALL_GROUPS_ID);

    const resolvedValues = !wasAllSelected && isAllSelected
      ? [ALL_GROUPS_ID]
      : newValues;

    const firstRealGroup = list.find(
      g => g.group_id !== ALL_GROUPS_ID && resolvedValues.includes(g.group_id),
    );
    const pId = firstRealGroup?.partner_id || partnerId;
    onChange(resolvedValues, pId);
  };

  return (
    <FormControl variant="outlined" className={className} style={style} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        label={label}
        value={value}
        renderValue={getDisplayValue}
        onChange={handleChange}
      >
        {list.map((item, index) => {
          const allSelected = value?.includes(ALL_GROUPS_ID);
          const isChecked = item.group_id === ALL_GROUPS_ID
            ? allSelected
            : (allSelected || value?.includes(item.group_id));
          const isDisabled = item.group_id !== ALL_GROUPS_ID && allSelected;
          return (
            <MenuItem
              key={item.group_id}
              value={item.group_id}
              data-testid={`${testIdPrefix}-${index}`}
            >
              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <CheckBox
                  checked={isChecked}
                  disabled={isDisabled}
                  readOnly
                  size="medium"
                  style={{ padding: 0, marginRight: 8, opacity: isDisabled ? 0.5 : 1 }}
                />
                {item.group_name}
              </div>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

GroupMultiSelect.propTypes = {
  list: PropTypes.array,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string,
  testIdPrefix: PropTypes.string,
  partnerId: PropTypes.string,
};

export default GroupMultiSelect;
